import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { F as FlexBox } from './Flex.styles-CT58so5w.js';

const Flex = ({
  children,
  alignContent = 'normal',
  alignItems = 'flex-start',
  basis,
  columnGap = 'none',
  direction = 'row',
  shrink,
  order,
  grow,
  justifyContent = 'flex-start',
  paddingBlockEnd = 'none',
  paddingBlockStart = 'none',
  paddingInlineEnd = 'none',
  paddingInlineStart = 'none',
  rowGap = 'none',
  wrap = 'nowrap',
  ...rest
}) => /*#__PURE__*/React__default.createElement(FlexBox, _extends({}, rest, {
  $basis: basis,
  $direction: direction,
  $alignContent: alignContent,
  $justifyContent: justifyContent,
  $alignItems: alignItems,
  $columnGap: columnGap,
  $grow: grow,
  $order: order,
  $rowGap: rowGap,
  $shrink: shrink,
  $wrap: wrap,
  paddingBlockEnd: paddingBlockEnd,
  paddingBlockStart: paddingBlockStart,
  paddingInlineEnd: paddingInlineEnd,
  paddingInlineStart: paddingInlineStart
}), children);

export { Flex as F };
//# sourceMappingURL=Flex-DBz5jrq6.js.map
